import { appOrigin } from "@/lib/absolute-url";
import { VIEWER_LOCALES } from "@garimpa/lib/viewerPreferences";

export function buildWebsiteJsonLd() {
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        "@id": `${appOrigin()}/#website`,
        url: appOrigin(),
        name: "Garimpa.Club",
        alternateName: "Garimpa",
        description:
          "Search physical music releases, track live offers, and get wishlist price-drop alerts.",
        inLanguage: [...VIEWER_LOCALES],
        publisher: { "@id": `${appOrigin()}/#organization` },
      },
      {
        "@type": "Organization",
        "@id": `${appOrigin()}/#organization`,
        name: "Garimpa.Club",
        url: appOrigin(),
        logo: {
          "@type": "ImageObject",
          "@id": `${appOrigin()}/#logo`,
          url: `${appOrigin()}/icon.svg`,
          contentUrl: `${appOrigin()}/icon.svg`,
          width: 512,
          height: 512,
        },
      },
    ],
  };
}
